<template>
  <div class="asd-loader">
    Čekám na data...
    <div class="states-block">
      <div v-for="(state, key) in states" :key="key"
           class="state"
           :class="[`state-${state.state}`]"
      >
        <div>{{ state.label }}</div>
        <div>
          <i v-if="state.state === 'finished'" class="fas fa-check"></i>
          <i v-else class="fas fa-sync-alt fa-spin"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from 'CORE/bus'

const HUMAN_READABLE_DISPATCH_NAME = {
    dataTypesLoad: 'Datové typy',
    propertyTypesLoad: 'Typy vlastností',
    projectTypesLoad: 'Typy projektů',
    taskTypesLoad: 'Typy úkolů',
    resourceTypesLoad: 'Typy zdrojů',
    resourceTypeFunctionsLoad: 'Funkce zdrojů',
    projectsLoad: 'Projekty',
    tasksLoad: 'Úkoly',
    resourcesLoad: 'Zdroje',
    usersLoad: 'Uživatelé',
    parametersLoad: 'Parametry',
    commentsLoad: 'Komentáře',
    attachmentsLoad: 'Přílohy',
    calendarsLoad: 'Kalendář',
    eventsLoad: 'Události',
    taskStatesLoad: 'Stavy úkolů',
    // aclLoad: 'ACL',
    groupsLoad: 'Uživatelské skupiny',
    companyTemplatesLoad: 'Šablony',
}

export default {
    name: 'Spinner',
    data() {
        return {
            states: {},
        }
    },
    mounted() {
        EventBus.$on('loadingStatus', e => {
            this.$set(this.states, e.dispatchName, {
                label: HUMAN_READABLE_DISPATCH_NAME[e.dispatchName],
                state: e.state,
            })
        })
    },
}
</script>

<style scoped lang="scss">
.asd-loader {
  color: firebrick;
  text-align: center;
  font-size: 1.5rem;
  margin: 5vh auto;
}
.state {
    font-size: 1rem;
    color: var(--color-secondary);
    margin: 2px;
    display: flex;
    flex-direction: row;
    & > div:first-child {
        width: 150px;
        text-align: left;
    }
    &-finished {
        color: green;
    }
    &-failed {
        color: red;
    }
}
.states-block {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: space-around;
    justify-content: space-evenly;
    width: 70%;
    margin: 10px auto;
}
</style>

